import React from 'react';
import ReactDOM from 'react-dom/client';
import { unstableSetRender } from 'antd';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// antd 5 рисует message/Modal.confirm через ReactDOM.render, которого нет в React 19
unstableSetRender((node, container) => {
  if (!container._reactRoot) container._reactRoot = ReactDOM.createRoot(container);
  const root = container._reactRoot;
  root.render(node);
  return async () => {
    await new Promise(resolve => setTimeout(resolve, 0));
    root.unmount();
    container._reactRoot = null;
  };
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
